<template>
  <div class="flex items-center gap-2 text-xl">
    <TextMultiline
      :text="i18n.t('sidebar.discoveryTools')"
      class="cursor-pointer"
      @click="router.push({ name: 'Discovery' })" />
    <p>/</p>
    <SmSkeleton v-if="loading" width="100px" />
    <div v-else-if="source" class="flex items-center gap-2 font-bold">
      <TextMultiline :text="source.name" />
    </div>
    <p v-else>
      {{ route.params.id }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { DataSource, DataSourcesService } from '@/client'
  import { useI18n } from 'vue-i18n'
  import { useRoute, useRouter } from 'vue-router'

  const i18n = useI18n()
  const route = useRoute()
  const router = useRouter()

  const source = ref<DataSource>()
  const loading = ref(true)

  onMounted(() => {
    loadDataSource()
  })

  function loadDataSource() {
    DataSourcesService.getDataSourceApiV1DataSourceDataSourcesDataSourceIdGet({
      dataSourceId: route.params.id as string,
    }).then((datasource) => {
      source.value = datasource
      loading.value = false
    })
  }
</script>

<style scoped lang="scss"></style>
